import { isBarbsDirectionParameter } from "@/constants/barbsParameters";
import { BarbsIconType, type BarbsIconTypeCustomOptions, getBarbsIconType } from "@/constants/layerConfigAttributes";
import { createDirectionParameterName } from "@/utility/createDirectionParameterName";

export const SpeedUnitsToSwitchToKn = ["ms", "bft", "kmh", "mph"];
export const ICON_NR_PLACEHOLDER = 50; //needed to choose a barb icon name for direction only barbs

export function getKnParameterName(parameter: string): string {
  const otherUnit = SpeedUnitsToSwitchToKn.find((unit) => parameter.includes(`:${unit}`));
  if (otherUnit) {
    return parameter.replace(`:${otherUnit}`, ":kn");
  }
  return parameter;
}

export function getBarbsPairedParameterUnit(parameterUnit: string): string {
  if (isBarbsDirectionParameter(parameterUnit)) {
    return parameterUnit;
  }

  return createDirectionParameterName(getKnParameterName(parameterUnit));
}

export function getBarbsIconTypeForParameter(
  parameterUnit: string,
  options?: BarbsIconTypeCustomOptions | null,
): BarbsIconType {
  if (isBarbsDirectionParameter(parameterUnit)) {
    return BarbsIconType.Arrows;
  }

  return getBarbsIconType(options);
}

export function getBarbsCustomOptionsForParameter<CustomOptions extends BarbsIconTypeCustomOptions>(
  parameterUnit: string,
  options?: CustomOptions | null,
): CustomOptions & { icon_type: BarbsIconType } {
  return {
    ...(options ?? ({} as CustomOptions)),
    icon_type: getBarbsIconTypeForParameter(parameterUnit, options),
  };
}

export function getBarbsLayerParameterSettings<CustomOptions extends BarbsIconTypeCustomOptions>(
  parameterUnit: string,
  options?: CustomOptions | null,
): {
  parameter_unit_paired: string;
  custom_options: CustomOptions & { icon_type: BarbsIconType };
} {
  return {
    parameter_unit_paired: getBarbsPairedParameterUnit(parameterUnit),
    custom_options: getBarbsCustomOptionsForParameter(parameterUnit, options),
  };
}
